// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-container{display:flex;flex-direction:column;align-items:center;width:100%;min-height:100vh;margin-top:130px}.page-container .page-loading{margin:160px 0 0 16px;width:320px;max-width:calc(100% - 32px)}@media(max-width: 480px){.page-container .page-loading{margin-left:0}}@media(max-width: 359px){.page-container .page-loading{max-width:calc(100% - 28px)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
